// extracted by mini-css-extract-plugin
export default {"newsletter":"HomeNewsletter_newsletter__Ojoty","content":"HomeNewsletter_content__Llyju","svgside":"HomeNewsletter_svgside__WPeRx","formside":"HomeNewsletter_formside__IeNtS"};